var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-center",attrs:{"label":true,"color":_vm.getColor(_vm.aula.tipo_de_aula),"x-small":""}},[_vm._v(" "+_vm._s(_vm.aula.tipo_de_aula || "- - -")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }